import React, { useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FAQ() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: '¿Tengo que dejar el café?',
    answer: 'No, solo aprenderemos a tomarlo en el momento en que no dañe tu claridad.'
  }, {
    question: '¿Es difícil de seguir?',
    answer: 'Está diseñado para mujeres ocupadas; las comidas son simples y los hábitos toman menos de 5 minutos.'
  }, {
    question: '¿Funciona si tomo terapia de reemplazo hormonal (TRH)?',
    answer: 'Sí, este protocolo potencia los beneficios de la TRH al limpiar el entorno celular.'
  }];
  return <section ref={ref} className="w-full bg-cream py-16 md:py-20" data-id="element-39">
      <div className="max-w-3xl mx-auto px-6" data-id="element-40">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.7
      }} data-id="element-41">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center text-teal-900" data-id="element-42">
            Preguntas Frecuentes
          </h2>

          <div className="space-y-4" data-id="element-43">
            {faqs.map((faq, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {
            opacity: 0,
            y: 20
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-white rounded-lg overflow-hidden shadow-sm" data-id="element-44">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex justify-between items-center text-left hover:bg-gray-50 transition-colors" data-id="element-45">
                  <span className="font-semibold text-lg text-gray-900" data-id="element-46">
                    {faq.question}
                  </span>
                  <motion.div animate={{
                rotate: openIndex === index ? 180 : 0
              }} transition={{
                duration: 0.3
              }} data-id="element-47">
                    <ChevronDownIcon className="w-5 h-5 text-gray-600" data-id="element-48" />
                  </motion.div>
                </button>

                <AnimatePresence data-id="element-49">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} className="overflow-hidden" data-id="element-50">
                      <div className="px-6 pb-5 text-gray-700 leading-relaxed" data-id="element-51">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}